import { render, staticRenderFns } from "./SectionHeader.vue?vue&type=template&id=738ec834&scoped=true&"
import script from "./SectionHeader.vue?vue&type=script&lang=js&"
export * from "./SectionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeader.vue?vue&type=style&index=0&id=738ec834&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ec834",
  null
  
)

export default component.exports